import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  Button,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.jsx';
import CompanyService from 'services/company2';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import ExtendFields from 'components/extendFields';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import InputLabel from '@material-ui/core/InputLabel';
import Public from '../public';
import Http from 'services/http2';
import User from 'services/user2';
import Util from 'lib/util';
import useDetail from 'hooks/useDetail';

/* dev
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fsale%2Fcustomer%2Forder%2Flist&response_type=code&scope=snsapi_base&state=123#wechat_redirect
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fpurchase%2Forder%2Flist&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/

function WwxCoprGroup(props) {
  const [error, setError] = useState(null);

  const { companyCode, inited, updateTs, detail, self } = useDetail(props, {});

  //初始化默认企业
  useEffect(() => {
    self.initWwx();
  }, [self]);

  self.initWwx = async function initWwx() {
    let wx = window.wx;
    let url = window.location.href;
    let authInfo = await getWwxAuthInfo();
    if (authInfo) {
      let authCorpId = authInfo.corpId;
      let permanentCode = authInfo.permanentCode;
      Http.post('/api/mp', {
        url,
        authCorpId,
        permanentCode,
        apiPath: '/initWwxAgentJsapi'
      }).then(rs => {
        if (rs.success) {
          let data = rs.data;
          wx.agentConfig({
            // corpid: 'ww3f2b7b9b075bd340', // 必填，企业微信的corpid，必须与当前登录的企业一致
            // agentid: '', // 必填，企业微信的应用id （e.g. 1000247）
            // timestamp: , // 必填，生成签名的时间戳
            // nonceStr: '', // 必填，生成签名的随机串
            // signature: '',// 必填，签名，见附录-JS-SDK使用权限签名算法
            corpid: authCorpId,
            ...data,
            jsApiList: ['createCorpGroupChat', 'selectCorpGroupContact'], //必填，传入需要使用的接口名称
            success: function (res) {
              // 回调
            },
            fail: function (res) {
              if (res.errMsg.indexOf('function not exist') > -1) {
                alert('版本过低请升级');
              }
            }
          });
        }
      });
    }
  };

  //查询企业微信永久授权码
  async function getWwxAuthInfo() {
    let postbody = {
      companyCode: User.getCompanyCode(),
      apiPath: '/archives/company/cWechat/get'
    };
    let authInfo;
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data;
        if (typeof data === 'string') {
          // {\"companyCode\":\"70267016\",\"corpId\":\"ww3f2b7b9b075bd340\",\"permanentCode\":\"tWQVJ-Qr6omjvR1hMScXw1uR503-LF8S9_wZCj396-Q\"}
          authInfo = Util.jsonDecode(data);
        }
      } else {
        setError({
          type: 'warn',
          title: response.errorMsg
        });
      }
    });
    return authInfo;
  }

  //上下游通讯录选人
  function selectCorpGroupContact() {
    window.wx.invoke(
      'selectCorpGroupContact',
      {
        fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示打开的通讯录从自己所在部门开始展示, 0表示从最上层开始。移动端，当需要展开的部门不在应用可见范围内，则从应用的可见范围开始展开。
        mode: 'multi', // 必填，选择模式，single表示单选，multi表示多选
        type: ['department', 'user'] // 必填，选择限制类型，指定department、user中的一个或者多个
        //selectedDepartmentIds: ['2', '3'], // 非必填，已选部门ID列表。用于多次选人时可重入
        //selectedUserIds: ['lisi', 'lisi2'], // 非必填，仅自建应用使用，第三方应用会忽略该字段，已选用户ID列表。用于多次选人时可重入
        //selectedOpenUserIds: ['wabc3', 'wbcde'], // 非必填，仅第三方应用使用，自建应用会忽略该字段，已选用户ID列表。用于多次选人时可重入
      },
      function (res) {
        if (res.err_msg === 'selectCorpGroupContact:ok') {
          if (typeof res.result === 'string') {
            res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
          }

          // var selectedDepartmentList = res.result.departmentList; // 已选的部门列表
          // for (var i = 0; i < selectedDepartmentList.length; i++) {
          //   var department = selectedDepartmentList[i];
          //   var departmentId = department.id; // 已选的单个部门ID
          // }

          // var selectedUserList = res.result.userList; // 已选的成员列表
          // for (var i = 0; i < selectedUserList.length; i++) {
          //   var user = selectedUserList[i];
          //   var userid = user.id; // 已选的单个成员ID，仅自建应用返回
          //   var openUserId = user.openUserId; // 已选的单个成员ID，仅第三方应用返回
          // }

          // var selectedCorpGroupDepartmentList =
          //   res.result.corpGroupDepartmentList; // 已选的部门列表
          // for (var i = 0; i < selectedCorpGroupDepartmentList.length; i++) {
          //   var corpGroupDepartment = selectedCorpGroupDepartmentList[i];
          //   var corpId = corpGroupDepartment.corpId; // 企业CORPID
          //   var departmentId = corpGroupDepartment.id; // 已选的单个部门ID
          // }

          var selectedCorpGroupUserList = res.result.corpGroupUserList; // 已选的已选企业互联成员列表

          // for (var i = 0; i < selectedGroupUserList.length; i++) {
          //   var corpGroupUser = selectedCorpGroupUserList[i];
          //   var corpId = corpGroupUser.corpId; // 企业CORPID
          //   var userId = corpGroupUser.id; // 已选的单个成员ID，仅自建应用返回
          //   var openUserId = corpGroupUser.openUserId; // 已选的单个成员ID，仅第三方应用返回
          // }

          // var selectedChainDepartmentList = res.result.chainDepartmentList; // 已选的部门列表
          // for (var i = 0; i < selectedChainDepartmentList.length; i++) {
          //   var chainDepartment = selectedChainDepartmentList[i];
          //   var corpId = chainDepartment.corpId; // 企业CORPID
          //   var departmentId = chainDepartment.id; // 已选的单个部门ID
          // }

          // var selectedChainUserList = res.result.chainUserList; // 已选的已选企业互联成员列表
          // for (var i = 0; i < selectedCorpGroupUserList.length; i++) {
          //   var chainUser = selectedCorpGroupUserList[i];
          //   var corpId = chainUser.corpId; // 企业CORPID
          //   var userId = chainUser.id; // 已选的单个成员ID，仅自建应用返回
          //   var openUserId = chainUser.openUserId; // 已选的单个成员ID，仅第三方应用返回
          // }
        }
      }
    );
  }

  //创建上下游会话
  async function createCorpGroupChat() {
    let userInfo = User.getUserInfo();

    // ww09b0e61976d36c7e
    window.wx.invoke(
      'createCorpGroupChat',
      {
        groupName: '讨论组', // 必填，会话名称。单聊时该参数传入空字符串""即可。
        corpGroupUserIds: [
          {
            corpId: 'ww3f2b7b9b075bd340',
            openUserId: 'woVLBJDAAAnnAzmBRmrRA5QwLbrHRa9w'
          },
          {
            corpId: 'ww3f2b7b9b075bd340',
            openUserId: 'woVLBJDAAAfLoFao4zutitkqJ3Q2SP8Q'
          },
          {
            corpId: 'ww3f2b7b9b075bd340',
            openUserId: 'woVLBJDAAAv8W61zCnm3fANiC9QX-INg'
          },
          {
            corpId: 'ww09b0e61976d36c7e',
            openUserId: 'woVLBJDAAAFK1SB63EOumb73UNngk_PQ'
          }
        ]
      },
      function (res) {
        if (res.err_msg === 'createCorpGroupChat:ok') {
          var chatId = res.chatId;
        }
      }
    );
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <div>
      <h3>上下游</h3>
      <Button
        onClick={selectCorpGroupContact}
        variant="contained"
        className="m-flex-item u-btn u-btn_line"
      >
        选人
      </Button>

      <Button
        onClick={createCorpGroupChat}
        variant="contained"
        className="m-flex-item u-btn u-btn_line"
      >
        创建会话
      </Button>
    </div>
  );
}

WwxCoprGroup.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(WwxCoprGroup);
